import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";

import { Input } from "components";
import { TAB_3B_TRIGGER_HELP_BLOCK, TAB_3B_UPDATE_INVOICE } from "actions";

const InfoIconInner = styled.div`
  background: ${props => props.bg};
  &:hover {
    filter: brightness(125%);
  }
`;

const InvoiceItem = props => {
  const { label, annualSales, approxCustomers, creditTerms, triggerHelpBlock, updateInvoice, domain } = props;
  return (
    <div className="invoice_slide" data-merge="1">
      <div className="inner_slide">
        <div className="invoice_slide--title">
          <h4>{label}</h4>
          <div className="info_icon">
            <InfoIconInner bg={domain.BaseColour} onClick={triggerHelpBlock} className="info_icon_inner">
              ?
            </InfoIconInner>
          </div>
        </div>
        <div className="invoice_slide--caption">
          <div>
            <label>{domain.Strings.tab3BCarouselItemSalesLabel}</label>
            <Input prefix={props.domain.Currency} addCommas onChange={updateInvoice} type="number" name="annualSales" value={annualSales} placeholder={domain.Strings.tab3BCarouselItemSalesPlaceholder} />
          </div>
          <div>
            <label>{domain.Strings.tab3BCarouselItemCustomersLabel}</label>
            <Input onChange={updateInvoice} type="number" name="approxCustomers" value={approxCustomers} placeholder={domain.Strings.tab3BCarouselItemCustomersPlaceholder} />
          </div>
          <div>
            <label>{domain.Strings.tab3BCarouselItemCreditLabel}</label>
            <Input onChange={updateInvoice} type="number" name="creditTerms" value={creditTerms} placeholder={domain.Strings.tab3BCarouselItemCreditPlaceholder} />
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state, ownProps) => {
  const { countryValue } = ownProps;
  return {
    ...state.app.countries.find(country => country.value === countryValue),
    domain: state.app.domain
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  const { countryValue } = ownProps;
  return {
    triggerHelpBlock: () => dispatch({ type: TAB_3B_TRIGGER_HELP_BLOCK }),
    updateInvoice: data => dispatch({ type: TAB_3B_UPDATE_INVOICE, countryValue, ...data })
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InvoiceItem);
